import { ChevronDown, ChevronUp, Pencil } from "lucide-react";

import { IgIconColors } from "@intelligems/ig-design-tokens/constants";
import { IgButton } from "@intelligems/ig-theme/IgButton";
import Stack from "@mui/material/Stack";

// Product picker trigger, matching the checkout rule builder: a blue "Select"
// button when empty; once there's a selection, a grey "Edit" button plus a
// "N selected" toggle. Cart rules select at the variant level but are always
// surfaced by product, so the copy and count are product-based either way. The
// list itself renders below the row via SelectedProductNames, so the parent
// owns `expanded`.
export const PickerButton = ({
  count,
  expanded,
  onEdit,
  onToggle,
}: {
  count: number;
  expanded: boolean;
  onEdit: () => void;
  onToggle: () => void;
}) => {
  if (count === 0) {
    return (
      <IgButton
        size="small"
        onClick={onEdit}
        sx={{ alignSelf: "flex-start", whiteSpace: "nowrap" }}
      >
        Select products
      </IgButton>
    );
  }

  const plural = count > 1 ? "s" : "";
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <IgButton
        size="small"
        startIcon={<Pencil size={16} color={IgIconColors.dark} />}
        onClick={onEdit}
        sx={{ whiteSpace: "nowrap" }}
      >
        Edit product{plural}
      </IgButton>
      <IgButton
        variant="text"
        size="small"
        endIcon={expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        onClick={onToggle}
        sx={{ whiteSpace: "nowrap" }}
      >
        {count} product{plural} selected
      </IgButton>
    </Stack>
  );
};
